/* Progressive enhancement only: native details navigation and anchor links work without JS. */
(() => {
  if (window.__mpnStorefrontFrame) return;
  window.__mpnStorefrontFrame = true;
  let actionObserver;
  let removeActionToggle;
  let galleryDialog;
  let galleryReturnFocus;
  const closeMenus = (returnFocus = false) => {
    document.querySelectorAll('[data-mpn-site-menu][open]').forEach((menu) => {
      menu.open = false;
      if (returnFocus) menu.querySelector('summary')?.focus();
    });
  };
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenus(true);
  });
  document.addEventListener('click', (event) => {
    const origin = event.target instanceof Element ? event.target : null;
    if (!origin) return;
    if (!origin.closest('[data-mpn-site-menu]') || origin.closest('[data-mpn-site-menu] a')) closeMenus();
    const zoomTrigger = origin.closest('[data-mpn-gallery-zoom]');
    if (zoomTrigger) {
      openGalleryZoom(zoomTrigger);
      return;
    }
    const action = origin.closest('a[href]');
    if (!action || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || action.hasAttribute('download') || (action.target && action.target !== '_self')) return;
    let destination;
    try { destination = new URL(action.href, document.baseURI); } catch { return; }
    if (destination.hash !== '#personalize' || destination.origin !== location.origin || destination.pathname !== location.pathname || destination.search !== location.search) return;
    const target = document.getElementById('personalize');
    if (!target) return;
    event.preventDefault();
    closeMenus();
    const panel = target.querySelector('[data-mpn-personalizer]');
    const scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    if (panel) {
      if(panel.tagName==='DETAILS'){panel.open = true;target.querySelectorAll('[data-mpn-open-personalizer]').forEach(trigger => trigger.setAttribute('aria-expanded', 'true'));}
      /* One scroll and one focus move. Never synthesize a CTA click, upload or submit. */
      panel.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
      (panel.querySelector('input[type=file]')||panel.querySelector('summary'))?.focus({ preventScroll: true });
      return;
    }
    target.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
    /* Move keyboard focus to the product, never submit a form or open the file picker automatically. */
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
  const openGalleryZoom = (trigger) => {
    const original = trigger.querySelector('img.lf-main-image');
    if (!original || !(original.currentSrc || original.getAttribute('src'))) return;
    if (!galleryDialog?.isConnected) {
      galleryDialog = document.createElement('dialog');
      galleryDialog.className = 'mpn-gallery-zoom';
      galleryDialog.setAttribute('aria-labelledby', 'mpn-gallery-zoom-title');
      galleryDialog.setAttribute('aria-describedby', 'mpn-gallery-zoom-caption');
      galleryDialog.innerHTML = '<div class="mpn-gallery-zoom__bar"><h2 id="mpn-gallery-zoom-title">A closer look.</h2><button type="button" class="mpn-gallery-zoom__close" aria-label="Close enlarged image" autofocus><span aria-hidden="true">×</span></button></div><figure><img class="mpn-gallery-zoom__image" alt=""><figcaption id="mpn-gallery-zoom-caption"></figcaption></figure>';
      document.body.append(galleryDialog);
      galleryDialog.querySelector('.mpn-gallery-zoom__close').addEventListener('click', () => galleryDialog.close());
      galleryDialog.addEventListener('click', (event) => {
        const rect = galleryDialog.getBoundingClientRect();
        if (event.target === galleryDialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) galleryDialog.close();
      });
      galleryDialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const controls = Array.from(galleryDialog.querySelectorAll('button, a[href], input, select, textarea, [tabindex]')).filter((item) => !item.disabled && item.tabIndex >= 0);
        const first = controls[0], last = controls[controls.length - 1];
        if (!first) return;
        if ((event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        }
      });
      galleryDialog.addEventListener('close', () => {
        galleryDialog.querySelector('img').removeAttribute('src');
        document.documentElement.classList.remove('mpn-gallery-zoom-open');
        if (galleryReturnFocus?.isConnected) galleryReturnFocus.focus({ preventScroll: true });
      });
    }
    const image = galleryDialog.querySelector('.mpn-gallery-zoom__image');
    const caption = galleryDialog.querySelector('figcaption');
    const galleryCaption = original.closest('.lf-gallery')?.querySelector('[data-lf-gallery-caption]')?.textContent.trim();
    image.src = original.currentSrc || original.src;
    image.alt = original.alt || 'Personalized pet necklace';
    const description = galleryCaption || image.alt;
    const isConcept = /\bAI\b|concept|illustrat/i.test(description + ' ' + image.alt);
    caption.textContent = isConcept && !/illustrat|finished engraving varies/i.test(description)
      ? description + ' — design illustration; finished engraving varies.'
      : description;
    galleryReturnFocus = trigger;
    if (!galleryDialog.open) galleryDialog.showModal();
    document.documentElement.classList.add('mpn-gallery-zoom-open');
    galleryDialog.querySelector('.mpn-gallery-zoom__close').focus({ preventScroll: true });
  };
  const installGalleryZoom = () => {
    if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
    document.querySelectorAll('.lf-gallery img.lf-main-image').forEach((image) => {
      if (image.closest('[data-mpn-gallery-zoom], button, a')) return;
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'mpn-gallery-zoom-trigger';
      trigger.setAttribute('data-mpn-gallery-zoom', '');
      trigger.setAttribute('aria-label', 'Enlarge current necklace image');
      trigger.setAttribute('aria-haspopup', 'dialog');
      image.before(trigger);
      trigger.append(image);
      const label = document.createElement('span');
      label.className = 'mpn-gallery-zoom-trigger__label';
      label.setAttribute('aria-hidden', 'true');
      label.textContent = 'A closer look ↗';
      trigger.append(label);
    });
  };
  const installMobileAction = () => {
    actionObserver?.disconnect();
    removeActionToggle?.();
    const action = document.querySelector('[data-mpn-mobile-action]');
    const product = document.getElementById('personalize');
    if (!action) return;
    action.hidden = true;
    if (!product || !('IntersectionObserver' in window)) return;
    const primary = product.querySelector('[data-mpn-open-personalizer]');
    const panel = product.querySelector('[data-mpn-personalizer]');
    if (!primary || !panel) return;
    const updateAction = () => {
      const primaryBox = primary.getBoundingClientRect();
      const panelBox = panel.getBoundingClientRect();
      const panelInUse = (panel.open || panel.hasAttribute('data-mpn-direct-upload')) && panelBox.bottom > 0 && panelBox.top < innerHeight;
      /* Appears after the actual start action, but never covers an open personalizer. */
      action.hidden = primaryBox.bottom > 0 || panelInUse;
    };
    actionObserver = new IntersectionObserver(updateAction, { threshold: 0 });
    actionObserver.observe(primary);
    actionObserver.observe(panel);
    panel.addEventListener('toggle', updateAction);
    removeActionToggle = () => panel.removeEventListener('toggle', updateAction);
    updateAction();
  };
  const installFrame = () => { installMobileAction(); installGalleryZoom(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installFrame, { once: true });
  else installFrame();
  document.addEventListener('shopify:section:load', installFrame);
  document.addEventListener('shopify:section:unload', installMobileAction);
  window.matchMedia('(min-width: 1101px)').addEventListener('change', (event) => { if (event.matches) closeMenus(); });
})();
